import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-22/task-02";

const task: Slide = {
  title: "The typical high cut-off of a subwoofer is:",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
